export default __webpack_public_path__ + "static/media/marie.1c682842.jpg";